// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPageTemplate_container__27a2B","content":"MainPageTemplate_content__1Qf_j","mobile":"MainPageTemplate_mobile__1ZI9x"};